<template>
  <div class="listBox">
    <div class="nav">
      <div class="nav_left" >
        <div class="icon" @click="goback" >
          <v-icon name="regular/arrow-alt-circle-left" scale="1.5"></v-icon>
        </div>
        <slot name="nav_left"></slot>
      </div>
      <div class="nav_left">
        <slot name="nav_right"></slot>
      </div>
    </div>
    <div class="content">
      <div class="contentMain">
        <slot name="content_right"></slot>
      </div>
    </div>
  </div>
</template>

<script>

import 'vue-awesome/icons/regular/arrow-alt-circle-left'
import systemImg from '@/assets/images/common/system_img.png'

export default {
  name: 'Content',
  props:{
    noBack:{
      type:Boolean,
      default:false,
      required:false,
    },
  },
  data () {
    return {
      companyInfo: '',
      systemImg,
      countNum: ''
    }
  },
  methods: {
    goback () {
      this.$emit('back')
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .listBox
    width 890px
    height 710px
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .nav
      color #FFF
      height $nav_height
      background $black_color
      font-size 18px
      /*margin 50px 0 30px*/
      display flex
      justify-content space-between
      box-sizing border-box
      user-select none
      .nav_left
        display flex
        align-items center
        .icon
          padding 0 20px
          cursor pointer
      .nav_left
        padding-right 20px
    .content
      color #FFF
      font-size 18px
      height $content_height
      display flex
      width 100%
      .contentMain
        background $black_color
        width 100%
        height 100%
        padding 0
        box-sizing border-box
        margin 0
        display flex
        flex-direction column
        color #FFF
        font-size 16px
</style>
